import React from "react";
import { Box, Typography } from "@mui/material";

interface SelectionSummaryProps {
  groups: number;
  series: number;
  /** Optional validation message shown when the selection is not a valid chart. */
  warning?: string;
}

/**
 * Compact "N groups × M series = K bars" summary, with an optional validation
 * warning when the minimums (>=1 visible group, >=2 visible series) are unmet.
 */
const SelectionSummary: React.FC<SelectionSummaryProps> = ({
  groups,
  series,
  warning,
}) => {
  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 1,
        backgroundColor: warning ? "#fdecea" : "#f0f7ff",
        border: `1px solid ${warning ? "#f5c6cb" : "#cfe3fb"}`,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {groups} {groups === 1 ? "group" : "groups"} × {series}{" "}
        {series === 1 ? "series" : "series"} = {groups * series}{" "}
        {groups * series === 1 ? "bar" : "bars"}
      </Typography>
      {warning && (
        <Typography variant="caption" sx={{ color: "#b71c1c", display: "block", mt: 0.5 }}>
          {warning}
        </Typography>
      )}
    </Box>
  );
};

export default SelectionSummary;
